import { z } from "zod";

const contributionHistoryItemSchema = z
  .object({
    id: z.string().min(1).max(128),
    date: z.string().nullable(),
    language: z.string().max(32).nullable(),
    contentType: z.string().min(1).max(40),
    durationMs: z.number().finite().nonnegative().nullable(),
    status: z.enum(["validated", "rejected", "pending"]),
    blobName: z.string().min(1).nullable().optional(),
    fileOrder: z.number().int().positive().safe().nullable().optional(),
    sourceFileId: z.number().int().positive().safe().nullable().optional(),
    sourceFileName: z.string().trim().min(1).max(255).nullable().optional(),
  })
  .strict();

export const contributionHistoryResponseSchema = z
  .object({
    data: z.array(contributionHistoryItemSchema).max(200),
    pagination: z
      .object({
        total: z.number().int().nonnegative().safe(),
        page: z.number().int().positive().safe(),
        limit: z.number().int().positive().safe(),
        pages: z.number().int().positive().safe(),
      })
      .strict(),
  })
  .strict();

export type ContributionHistoryResponse = z.infer<
  typeof contributionHistoryResponseSchema
>;

export type ContributionHistoryItem = ContributionHistoryResponse["data"][number];

export type ContributionHistoryStatus = ContributionHistoryItem["status"];
